import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as profileStatus from '../redux/profile/status';
import { getProfile } from '../redux/profile/actions';
import * as singleCheckStatus from '../redux/singleCheck/status';
import { getSingleCheck } from '../redux/singleCheck/actions';

export default class GetSingle extends Component {
  static propTypes = {
    children: PropTypes.node,
    object: PropTypes.object,
    type: PropTypes.string,
  }

  static defaultProps = {
    children: null,
    object: null,
    type: 'profile',
  }

  static contextTypes = {
    store: PropTypes.object,
  }

  getProfile = async (obj) => {
    const { store } = this.context;
    const body = {
      userID: obj.userID,
      profileID: obj.profileID,
    };

    this.setState({
      userID: obj.userID,
      profileID: obj.profileID,
    });

    const res = await store.dispatch(getProfile(body));
    const { profileID, userID } = this.state;
    if (res === profileStatus.PROFILE_STATUS_OK) {
      window.open(`/user/pid=${profileID}&uid=${userID}`); 
      return;
    }
  }

  getCheck = async (obj) => {
    const { store } = this.context;
    const body = {
      userID: obj.userID,
      checkID: obj.checkID,
    };

    this.setState({
      userID: obj.userID,
      checkID: obj.checkID,
    });

    const res = await store.dispatch(getSingleCheck(body));
    const { checkID, userID } = this.state;
    if (res === singleCheckStatus.SINGLECHECK_STATUS_OK) {
      window.open(`/check/cid=${checkID}&uid=${userID}`); 
      return;
    }
  }

  getType = (obj) => {
    const { type } = this.props;
    if (type === 'profile') {
      return this.getProfile(obj);
    }
    if (type === 'check') {
      return this.getCheck(obj);
    }
  }

  render() {
    const { children, object } = this.props;
    return (
      <button
        className="buttonLink"
        onClick={() => this.getType(object)}
      >
        {children}
      </button>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/GetSingle.jsx